import { Component, OnInit, TemplateRef, NgZone, OnDestroy, OnChanges} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CuentaService } from '../../service/cuenta.service';
import { CodeCountry } from '../../util/nexus-code';
import { Usuario } from '../../clases/usuario';
import { environment } from '../../../environments/environment';
import { UserService } from '../../service/user.service';
import { InitParams, FacebookService, LoginOptions, LoginResponse } from '@jemys89/ngx-facebook';
import { Foto } from '../../clases/foto';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '../../service/alert.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DatosCompartidosService } from '../../service/datos-compartidos.service';
import { modalService} from '../../service/modal.service';
import { DatosFb } from '../../clases/datos-fb';
import { Subscription } from 'rxjs';
import { Nexus } from '../../util/nexus';
import * as Cookies from '../../util/cookies/cookies';
import { GoogleAnalyticsService } from 'mugan86-ng-google-analytics';


@Component({
  selector: 'app-verify-code',
  templateUrl: './verify-code.component.html',
  styleUrls: ['./verify-code.component.css']
})
export class VerifyCodeComponent implements OnInit, OnDestroy {

  //FORMULARIO
  registroForm: FormGroup;
  //PAIS
  pais: any;
  paisCode;

  //PREFIJO
  prefijoCurrent: String = 'PE';

  codeCountry: any[] = [];

  prefijo: any

  showButtonGA : boolean
  //Modal
  modalRef: BsModalRef;

  //BUTTON
  btnRegistrarUsuarioDisabled: boolean = false;
  showBtnRegistrarUsuario: number = 1;
  showBtnConectarFB: number = 1;

  //Obj
  public user: Usuario = new Usuario();
  datosFB: any;

  //FB
  options: LoginOptions = {
    scope: 'email, public_profile',
    return_scopes: true,
    enable_profile_selector: true
  };
  picture: Foto;
  btnDisabledCFB: boolean = false;
  iconChkFB: boolean = false;

  registroFB: number = 2;

  objDatosFB: DatosFb = new DatosFb();

  txtNombre: string;
  txtApellido: string;
  txtEmail: string;

  olvideContrasenia: boolean = false;
  showPassword: boolean = false;
  id: number;

  txtDNI: string;
  //
  dataSubscription: Subscription;
  solicitarButtonGenerica : boolean = true;
  //LOGO
  logo = {
    url: environment.LOGO_INICIO_SESION.URL,
    alt: environment.LOGO_INICIO_SESION
  }

  inicioFb = environment.INICIO_FB;
  codcliente :string
  constructor(
    private cuentaService: CuentaService,
    private formBuilder: FormBuilder,
    private _userService: UserService,
    private fb: FacebookService,
    private router: Router,
    private alertService: AlertService,
    private _datosCompartidos: DatosCompartidosService,
    private ruta: ActivatedRoute,
    private modal:modalService,
    public googleAnalyticsService: GoogleAnalyticsService
  ) {

    // this.solicitarButtonGenerica == environment.VALIDACIONES_SOLICITAR.FLAG_GA;
    if (environment.INICIO_FB) {
      let initParams: InitParams = {
        appId: environment.APPIDFB,
        xfbml: true,
        version: 'v3.1'
      };

      fb.init(initParams);
    }
  }

  ngOnInit() {
    this.codcliente = environment.CODCLIENTE
    this.showButtonGA = environment.VALIDACIONES_SOLICITAR.FLAG_GA;

    if (Nexus.getCountryCode().country == environment.CONF_PAIS.PAISES.BOLIVIA.CODE) {
      this.txtDNI = environment.CONF_PAIS.PAISES.BOLIVIA.DNI;
    } else if (Nexus.getCountryCode().country == environment.CONF_PAIS.PAISES.CHILE.CODE) {
      this.txtDNI = environment.CONF_PAIS.PAISES.CHILE.RUC;
    } else if (Nexus.getCountryCode().country == environment.CONF_PAIS.PAISES.PERU.CODE) {
      this.txtDNI = environment.CONF_PAIS.PAISES.PERU.DNI;
    } else if (Nexus.getCountryCode().country == environment.CONF_PAIS.PAISES.EC.CODE) {
      this.txtDNI = environment.CONF_PAIS.PAISES.EC.DNI;
    } else if (Nexus.getCountryCode() == environment.CONF_PAIS.PAISES.CHILE.CODE) {
      this.txtDNI = environment.CONF_PAIS.PAISES.CHILE.RUC;
    } else if (Nexus.getCountryCode().country == environment.CONF_PAIS.PAISES.MEXICO.CODE) {
      this.txtDNI = environment.CONF_PAIS.PAISES.MEXICO.RUC;
    }else if (Nexus.getCountryCode().country == environment.CONF_PAIS.PAISES.COSTA_RICA.CODE) {
      this.txtDNI = environment.CONF_PAIS.PAISES.COSTA_RICA.DNI;
    }

    if(!this.txtDNI){
      this.txtDNI = environment.CONF_PAIS.PAISES.PERU.DNI;
    }

    this.codeCountry = CodeCountry.CODECOUNTRY;

    if(Nexus.getCountryCode().country==undefined){
      this.prefijo = this.codeCountry.filter(x => x.code == environment.COUNTRY)[0];
    } else {
      this.prefijo = this.codeCountry.filter(x => x.code == Nexus.getCountryCode().country)[0];
    }

    this.id = +this.ruta.snapshot.paramMap.get('id');
    if (this.id) {
      this.btnDisabledCFB = true;
      this.dataSubscription = this._datosCompartidos.getDatosRegistroFB().subscribe((data: any) => {


        this.objDatosFB = data;
        //console.log(this.objDatosFB.picture.data.url);

      });

    }


    const country = JSON.parse(localStorage.getItem('country'));
    if(country.country==undefined){
      this.paisCode = country;
    }else{
      this.paisCode = country.country;
    }

    this.getCountryService();

    this.registroForm = this.formBuilder.group({
      'txtEmail': ['', [Validators.required]],
    });
    //  this.prefijo = this.codeCountry.find(prefijo => prefijo.code ==Nexus.getCountryCode().country)


  }


  getCountryService() {
    const paises = require('../../globals/country.json');
    this.pais = paises;
  }

  get fRegistro() {
    return this.registroForm.controls;
  }

  onVerifyEmail(){
    let email = localStorage.getItem('email');
    this._userService.onVerifyCodeService(this.fRegistro.txtEmail.value,email).
    subscribe((data:any)=>{
      let usuario = data
      localStorage.setItem("idcliente",usuario.IdCliente);
      localStorage.setItem("idRol",usuario.Rol);
      localStorage.setItem("email",usuario.Email);
        this.router.navigate(['/registro']);

    },
    (error:any)=>{
      this.alertService.error('', error.error);
    })
  }
  registrar() {
    const element = document.getElementById('btnRegistrarUsuario');
    // this.modal.cargar();
    let user: Usuario = new Usuario();
    // user.CentroCosto_Codigo = "Default"
    user.NombreCompleto = this.fRegistro.txtNombre.value + ' ' + this.fRegistro.txtApellidoPaterno.value;
    user.Nombres = this.fRegistro.txtNombre.value;
    user.Paterno = this.fRegistro.txtApellidoPaterno.value;
    user.Materno = this.fRegistro.txtApellidoMaterno.value;
    user.DocumentoIdentidad = this.fRegistro.txtDNI.value;
    user.Celular = this.fRegistro.txtTlf.value;
    user.Email = this.fRegistro.txtEmail.value;
    user.Clave = this.fRegistro.txtClave.value;
    user.Rol = environment.ROL.PARTICULAR;
    user.IdCentroCosto = environment.CENTRO_COSTO.PARTICULAR;
    const prefijoDialCode = this.prefijo.dial_code;
    user.prefijo = prefijoDialCode.replace('+', '');
    user.isoCountryCode = this.fRegistro.txtPais.value;
    this.btnRegistrarUsuarioDisabled = !this.btnRegistrarUsuarioDisabled;
    this.showBtnRegistrarUsuario = 2;
    user.Dias = '1111111';
    user.EstadoPresupuesto = false;
    user.lstCentroCosto = [environment.CENTRO_COSTO.PARTICULAR];

    if(environment.VALIDAR_GRUPO_NEGOCIO.ACTIVO){
      user.idGrupoNegocio = environment.VALIDAR_GRUPO_NEGOCIO.IDGRUPONEGOCIO;
    }

    if(environment.CODCLIENTE == 'NXVMOVICAB'){
      if (this.expression_regular_validación_movicab.test(user.Clave)) {
        this.onRegisterUser(user, element);

        console.log("Contraseña válida.");
    } else {
        console.log("Contraseña no válida.");
    }
    }else {
      this.onRegisterUser(user, element);
    }

  }

  private onRegisterUser(user: Usuario, element: HTMLElement) {
    this._userService.requestRegistrar(user).subscribe((data: any) => {
      // console.log(user);
      if (data.idResultado === 1) {
        setTimeout(() => {
          this.showBtnRegistrarUsuario = 3;
          element.classList.remove('btn-primary');
          element.classList.add('btn-success');
          //this.ref.detectChanges();
        }, 2000);
        Cookies.cookieTokenAdd(data.resultado);

        if (this.objDatosFB.picture != null) {


          this._userService.fotoFB(this.objDatosFB.picture.data.url, data.value).subscribe(
            (res: any) => {
              const currentUser = {
                IdCliente: data.value,
                Rol: user.Rol
              };


              if (res) {

                this.cuentaService.postGuardarFoto(res).subscribe((dataFoto: any) => {
                  if (parseInt(dataFoto.idResultado) > 0) {



                    localStorage.setItem('currentUser' + '_' + environment.NOMBRE_EMPRESA, JSON.stringify(currentUser));
                    // Cookies.cookieTokenAdd();
                    this.router.navigate(['/default']);
                  } else {
                    this.alertService.clear();
                    this.alertService.error('', 'Error al guardar la Foto');
                  }
                }, (error) => {
                  console.log('Error al guardar la Foto');
                  localStorage.setItem('currentUser' + '_' + environment.NOMBRE_EMPRESA, JSON.stringify(currentUser));
                  // Cookies.cookieTokenAdd();
                  this.router.navigate(['/default']);
                });
              } else {
                localStorage.setItem('currentUser' + '_' + environment.NOMBRE_EMPRESA, JSON.stringify(currentUser));
                // Cookies.cookieTokenAdd();
                this.router.navigate(['/default']);
              }


            },
            (error) => {
              this.alertService.error(error);
            }
          );
        } else {
          const currentUser = {
            IdCliente:   data.value,
            Rol: user.Rol
          };

          localStorage.setItem('currentUser' + '_' + environment.NOMBRE_EMPRESA, JSON.stringify(currentUser));
          this.router.navigate(['/default']);

        }


        this.alertService.error('', environment.MENSAJES.LOGIN.ERROR.DESCRIPCION);
      } else if (data.idResultado == environment.MENSAJES.LOGIN.USUARIO_INACTIVO.CODIGO) {
        //Clave incorrecta
        this.alertService.error('', environment.MENSAJES.LOGIN.USUARIO_INACTIVO.DESCRIPCION);
        this.showBtnRegistrarUsuario = 1;
        element.removeAttribute('disabled');
      } else if (data.idResultado == environment.MENSAJES.LOGIN.CLAVE_INCORRECTA.CODIGO) {
        this.showBtnRegistrarUsuario = 1;
        element.removeAttribute('disabled');
        this.alertService.error('', environment.MENSAJES.LOGIN.CLAVE_INCORRECTA.DESCRIPCION);

      } else if (data.idResultado == environment.MENSAJES.LOGIN.NO_EXISTE_USUARIO.CODIGO) {
        this.alertService.error('', environment.MENSAJES.LOGIN.NO_EXISTE_USUARIO.DESCRIPCION);
        this.showBtnRegistrarUsuario = 1;
        element.removeAttribute('disabled');

      } else if (data.idResultado == environment.MENSAJES.LOGIN.ERROR.CODIGO) {
        this.alertService.error('', data.resultado);
        this.showBtnRegistrarUsuario = 1;
        element.removeAttribute('disabled');

      } else if (data.idResultado == environment.MENSAJES.LOGIN.CORREO_DUPLICADO.CODIGO) {
        this.showBtnRegistrarUsuario = 1;
        element.removeAttribute('disabled');
        this.alertService.error('', environment.MENSAJES.LOGIN.CORREO_DUPLICADO.DESCRIPCION);
      } else if (data.idResultado == environment.MENSAJES.LOGIN.CORREO_SIN_ACCESOS.CODIGO) {
        this.showBtnRegistrarUsuario = 1;
        element.removeAttribute('disabled');
        this.alertService.error('', environment.MENSAJES.LOGIN.CORREO_SIN_ACCESOS.DESCRIPCION);
      }
    },



      (error) => {
        this.alertService.error('', environment.MENSAJES.LOGIN.ERROR.DESCRIPCION);
      });
  }

  setPrefijo(sel: any) {
    this.prefijo = sel;
  }

  clickPrefijo(prefijo: any) {
    this.prefijoCurrent = prefijo.code;
  }


  loginFB() {
    this.fb.login(this.options)
      .then((res: LoginResponse) => {
        this.fb.api('/me', 'get',
          { "fields": "email,first_name,last_name,picture" })
          .then(resp => {
            // console.log(resp);

            //console.log(this.datosFB)

            setTimeout(() => {
              this.showBtnConectarFB = 3;
              this.objDatosFB = resp;
            }, 2000);



          })
          .catch(e => {
            this.showBtnConectarFB = 1;
            this.btnDisabledCFB = !this.btnDisabledCFB;
            this.alertService.error('', environment.MENSAJES.LOGIN.ERROR.DESCRIPCION);
            //  console.log(e)
          });




      })
      .catch(e => {
        this.showBtnConectarFB = 1;
        this.btnDisabledCFB = !this.btnDisabledCFB;
        this.alertService.error('', environment.MENSAJES.LOGIN.ERROR.DESCRIPCION);
        // console.log(e)
      }
      );
  }

  obtenerDatosFB() {

    this.showBtnConectarFB = 2;
    this.loginFB();

  }



  decline(): void {
    this.modalRef.hide();
  }



  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }



  public ngOnDestroy(): void {
    console.log('se destruye');

    if (this.id) {
      this.dataSubscription.unsubscribe();
    }


  }
  sendRegistrar(){
    this.googleAnalyticsService.eventEmitter('botón', 'clic', 'registrarme');
  }

  expression_regular_validación_movicab = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d|\W).{8,}$/;

}
